import update from 'immutability-helper';

import { SET, ADDED, UPDATED, DELETED } from './actions';
import * as questionsActions from "../questions/actions";

const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.excludings;

    case ADDED:
      return {
        ...state,
        [action.excluding.id]: action.excluding
      };

    case UPDATED:
      return update(state, {
        [action.excluding.id]: {
          $set: action.excluding
        }
      });
    case DELETED:
      return update(state, {
        $unset: [action.excluding.id]
      });

    case questionsActions.TYPE_UPDATED:
      const ids = [];

      _.each(state, excluding => {
        if (excluding.question.id === action.expiredId)
          ids.push(excluding.id);
      });

      return update(state, {
        $unset: ids
      });

    default:
      return state;
  }
};